import React from 'react'

import { useStyles } from './legend-key.style'

const LEGEND_CIRCLE_RADIUS = 5

export const LEGEND_SHAPE = {
  CIRCLE: 'circle',
  RECT: 'rect'
}

export function LegendKey ({ label, color, shape, disabled = false }) {
  const classes = useStyles()

  return (
    <>
      {shape === LEGEND_SHAPE.CIRCLE
        ? (
          <div className={disabled ? classes.disabledKey : ''}>
            <svg width={LEGEND_CIRCLE_RADIUS * 2} height={LEGEND_CIRCLE_RADIUS * 2}>
              <circle cx={LEGEND_CIRCLE_RADIUS} cy={LEGEND_CIRCLE_RADIUS} r={LEGEND_CIRCLE_RADIUS} fill={color} />
            </svg>
          </div>
        )
        : <div className={classes.legendRect} style={{ backgroundColor: color }} />
      }
      <div className={`${classes.legendLabel} ${disabled ? classes.disabledKey : ''}`}>
        {label}
      </div>
    </>
  )
}
